import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { User } from '../types/user';
import { SpinnerService } from './spinner.service';
import { HsApiService } from './hs-api.service';

@Injectable({
  providedIn: 'root'
})
export class PrivacyNoticeService {
  private isPrivacyWindow = false;
  user: User;

  constructor(
    private spinner: SpinnerService,
    private hsApi: HsApiService
  ) {}

  setUser(sessionuser: User) {
    this.user=sessionuser
  }
  getUser(): User {
    return this.user;
  }
  setPrivacyNoticeOpen() {
    this.isPrivacyWindow=true;
  }
  setPrivacyNoticeClose() {
    this.isPrivacyWindow=false;

  }
  isPrivacyWindowOpen(): Boolean {
    return this.isPrivacyWindow;
  }
  actionUserAccept(UserPoolId:string, Username:string) {
    this.hsApi
        .privacynoticeAccept(
            UserPoolId,
            Username
        )
        .subscribe(data => {
            this.spinner.hideSpinner();
        }, this.handleError);
  }
  actionUserDecline(UserPoolId:string, Username:string) {
    this.hsApi
        .privacynoticeDecline(
            UserPoolId,
            Username
        )
        .subscribe(data => {
            this.spinner.hideSpinner();
        }, this.handleError);
  }
  private handleError = err => {
    const response = _.get(err, 'error', err);
    this.spinner.hideSpinner();
  };
}
